module.exports = __webpack_public_path__ + "img/PayMethod-Cash.2c5bad6e.png";